






import Vue from "vue";
import StoreViewer from "./StoreViewer.vue";

export default Vue.extend({
  name: "Stores",
  components: { StoreViewer },
  props: {},
  data: () => ({}),
});
